import React, { useEffect, useRef, useState } from 'react';
import { ArrowCircleLeft, ArrowCircleRight, ArrowLeft, Clock, Eye } from 'iconsax-react';
import { Link, useNavigate } from 'react-router-dom';
// import { useSingleProperty } from '../../../Services/hooks/SingleProperty';
import { User, userData } from '../../../Storeredux/constants/actionTypes';
// import { ObjectType } from '../../../Services/constant/serviceType';
import { ReactComponent as Delete } from '../../../Assets/Icons/delete.svg';
// import { ReactComponent as EmployeeProfile } from '../../../Assets/Icons/employeeprofile.svg';
import { useEmployee } from '../../../Services/hooks/employee';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Storeredux/reducers/rootReducer';
import Loader from '../../../Components/Loader/Loader';

function AllEmployee() {
  const navigate = useNavigate();
  // const location = useLocation();
  // const pageName = location.pathname;
  // pageName = pageName.split('/').pop() || '';
  // const { propertyDetails } = useSingleProperty();
  const { getAllEmployee, allEmployee, loading } = useEmployee();
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  console.log(user, 'pageName');

  const images = [
    'hdhhd',
    'hdhhd',
    'hdhdhd',
  ];


  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = useRef({
    className: 'flex fle ',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index: any) => setCurrentSlide(index),
    nextArrow: <ArrowCircleRight size="35" color={currentSlide === images.length - 1 ? '#8E8E93' : '#286722' } variant="Bold" />,
    prevArrow: <ArrowCircleLeft size="35" color={currentSlide === 0 ? '#8E8E93' : '#286722' } variant="Bold" />,
  });
  const size = useRef(40);
  const sliderSettings = () => {
    size.current = 20;
    settings.current = {
      ...settings.current,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
  };
  sliderSettings();

  useEffect(() => {
    getAllEmployee(user.id);
  }, []);
  return (
    <div className='py-10'>
      <div className='w-11/12 mx-auto'>
        <div className='flex items-center gap-2 p-3 cursor-pointer bg-custom-button-green rounded-full w-fit'>
          <ArrowLeft size="32" color="#000000" onClick={() => navigate(-1)}/>
          {/*<p className='font-semibold'>Property Detail</p>*/}
        </div>
        <div className='rounded-3xl mx-auto px-3 py-6 md:px-5 '>
          <div className={'pb-6'}>
            <h1 className={'text-xl font-bold'}>Manage Employee </h1>
            <p className={'text-sm font-light py-2'}>Stay up-to-date with your laguda’s rental journey and property interactions.</p>
          </div>
          <div className="">
            <div className=' py-2 border border-custom-grey rounded-custom bg-white'
                 style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
              <div className={'flex justify-between items-center py-6 px-3.5'}>
                <h1 className=" lg:text-sm text-xs ">
                  Employee’s on Monthly Rent
                </h1>
                <div className={'flex gap-3'}>
                  <button
                    className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                    <Clock size="22" color="#20996B" />
                    Filter By Date
                  </button>
                  <button
                    className={'border border-custom-lemongreen flex gap-2 items-center rounded-lg text-xs lg:text-sm py-1 px-2 text-custom-green'}>
                    <Clock size="22" color="#20996B" />
                    Export
                  </button>
                  {/*<button*/}
                  {/*  className={'border bg-custom-midnightgreen flex gap-2 items-center rounded text-sm py-1 px-4 text-white'}>*/}
                  {/*  Add Employee*/}
                  {/*</button>*/}
                </div>
              </div>
              <table className="w-full">
                <thead className="font-semibold text-xxs lg:text-xs bg-custom-light-green uppercase">
                <tr className="text-left">
                  <th className="py-4 px-4">S/N</th>
                  <th >Employee Name</th>
                  <th>Employee Email</th>
                  <th>amount per month</th>
                  <th>amount left</th>
                  <th >action</th>
                </tr>
                </thead>
                {
                  loading ? (
                      <tbody>
                      <tr>
                        <td colSpan={10} className="py-5 px-2">
                          <div className="flex flex-col justify-center items-center w-full py-16">
                            <Loader />
                          </div>
                        </td>
                      </tr>
                      </tbody>
                  ) :
                    allEmployee.length !== 0 ?
                      <tbody>
                      {
                        allEmployee.map((historyData: User, index: any) =>
                          <tr key={index}
                              className="font-semibold text-xxs sm:text-xs text-center uppercase border-b-2 border-custom-light-green">
                            <td className="py-4">{index + 1}</td>
                            <td >{historyData?.name}</td>
                            <td>{historyData?.email}</td>
                            <td>{historyData?.employee[0]?.house_type || 'Full-Time'}</td>
                            <td>{historyData?.employee[0]?.amount_per_month || 0}</td>
                            <td>
                              <div className={'flex justify-center items-center gap-4'}>
                                {/*<Edit size="20" color="#000"/>*/}
                                <Link to={`/app/allemployees/${historyData?.id}`}>
                                  <Eye size="20" color="#000" variant="Bold" />
                                </Link>
                                <Delete style={{ width: '20px', height: '20px', fill: '#000' }} />
                              </div>
                            </td>
                          </tr>,
                        )
                      }
                      </tbody>
                      :
                      <tbody>
                      <tr>
                        <td colSpan={6} className="">
                          <div className="flex flex-col justify-center items-center w-full py-16">
                            <p className="text-sm pt-1">No Employee Yet </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                }


                {/*{*/}
                {/*  allEmployee?.length !== 0 ?*/}
                {/*  <tbody>*/}
                {/*  {*/}
                {/*    allEmployee?.map((historyData: User, index) =>*/}
                {/*      <tr key={index} className="font-semibold text-xxs sm:text-xs uppercase border-b-2 border-custom-light-green">*/}
                {/*        <td className="py-4 px-4">{historyData?.sn}</td>*/}
                {/*        <td className={'md:table-cell hidden'}>{historyData?.name}</td>*/}
                {/*        <td>{historyData?.email}</td>*/}
                {/*        <td>{historyData?.employee[0].amount_per_month}</td>*/}
                {/*        <td>{historyData?.employee[0].amount_per_month}</td>*/}
                {/*        <td>*/}
                {/*          <div className={'flex justify-start items-center gap-4'}>*/}
                {/*            /!*<Link to={'habeeb'}>*!/*/}
                {/*            /!*  <Eye size="20" color="#000" variant="Bold"/>*!/*/}
                {/*            /!*</Link>*!/*/}
                {/*            <EmployeeProfile />*/}
                {/*            <Delete style={{ width: '20px', height: '20px', fill: '#000' }} />*/}
                {/*          </div>*/}
                {/*        </td>*/}
                {/*      </tr>)*/}
                {/*  }*/}
                {/*  </tbody>*/}
                {/*    :*/}
                {/*  <tbody>*/}
                {/*  <tr>*/}
                {/*    <td colSpan={6} className=''>*/}
                {/*      <div className='flex flex-col justify-center items-center w-full py-16'>*/}
                {/*        <p className='text-sm pt-1'>No Transaction Yet </p>*/}
                {/*      </div>*/}
                {/*    </td>*/}
                {/*  </tr>*/}
                {/*  </tbody>*/}
                {/*}*/}
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
  ;
}

export default AllEmployee;
